import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertCircle } from 'lucide-react';
import Colors from '../../../constants/Colors';
import PageSkeleton from '../../../components/PageSkeleton';
import CargoVarietiesChart from './CargoVarietiesChart';
import { useCargoVarietiesData } from '../../../utils/api-hooks/analytics';

const CargoVarietiesChartContainer = ({ apiParams, presetViewId, ...rest }) => {
  const { t } = useTranslation();
  const { email, commodity } = apiParams || {};
  const isPresetView2 = presetViewId === 'view2';

  const {
    available,
    availableCommodities,
    unavailableMessage,
    periods,
    metadata,
    isLoading,
    isError,
    error,
  } = useCargoVarietiesData(email, commodity);

  if (isLoading) {
    return <PageSkeleton shape="chart" />;
  }

  if (isError) {
    return (
      <div
        className={
          (isPresetView2 ? 'w-full min-h-[240px] py-16' : 'h-full w-full') +
          ' flex flex-col items-center justify-center gap-3 px-4'
        }
      >
        <AlertCircle size={32} style={{ color: Colors.error || '#ef4444' }} />
        <p className="text-gray-400 text-sm text-center">
          {error?.message || t('charts.errorLoading')}
        </p>
      </div>
    );
  }

  return (
    <CargoVarietiesChart
      available={available}
      availableCommodities={availableCommodities}
      unavailableMessage={unavailableMessage}
      periods={periods}
      metadata={metadata}
      {...rest}
    />
  );
};

export default CargoVarietiesChartContainer;
